import { ListRegistryUsersDto } from "types/dto/ListRegistryUsersDto"
import { ApiService } from "./apiService"
import { RegistryUserDto } from "types/dto/RegistryUserDto"



export const getRegistryUsers = async (dto: ListRegistryUsersDto) => {
    return await ApiService.get(`registries/${dto.registryId}/users?status=${dto.status}`)
}

export const RevokeRegistryUser = async (dto: RegistryUserDto) => {
    return await ApiService.delete(`registries/${dto.registryId}/users/${dto.userId}`);
}